export type Density = 'comfortable' | 'compact'
const KEY = 'expas-density'

export function getDensity(): Density {
  return (document.documentElement.getAttribute('data-density') as Density) ?? 'comfortable'
}

export function setDensity(d: Density) {
  document.documentElement.setAttribute('data-density', d)
  localStorage.setItem(KEY, d)
}

export function initDensity() {
  setDensity((localStorage.getItem(KEY) as Density | null) ?? 'comfortable')
}
